import React, { Fragment, useEffect, useState } from 'react';
import DocumentManagement from './DocumentManagement';

const Index = () => {
    let a = localStorage.getItem("admin")
    const [Administrator, setAdministrator] = React.useState(a);

    return (
        <div className="content">
            <div className="container-fluid">
                <br />
                <div className="card">
                    <div className="card-body">
                        <DocumentManagement />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;